import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import { ErrorScope } from 'src/shared/constants/ErrorScope';

const useErrorScope = (scope: ErrorScope) => {
  useEffect(() => {
    if (scope) {
      Sentry.setTag('scope', scope);
    }

    // unset tag as part of cleanup
    return () => Sentry.setTag('scope', undefined);
  }, [scope]);
};

export { useErrorScope };
